import { render } from "./MoMoOfficial.vue?vue&type=template&id=3000bc3c"
import script from "./MoMoOfficial.vue?vue&type=script&lang=js"
export * from "./MoMoOfficial.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__